

import React, { useState, useContext, useEffect } from 'react';
import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Card,
  CardContent,
  InputAdornment,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import TvIcon from '@mui/icons-material/Tv';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { motion } from 'framer-motion';
import axios from 'axios';
import JSEncrypt from 'jsencrypt';
import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from '../context/UserContext';
import { AuthContext } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';
import { decryptAES, encryptAES } from '../utils/cryptoUtils';
import { updateUserIdSSO } from '../utils/apiClient3';
import { useNavigate } from "react-router-dom";

// import { setInMemoryNTID } from '../utils/apiClient'; // my new function for frontend
import apiClient from '../utils/apiClient';
//this is for only login of our app --> ntid and pass will be checked --> then they will again hit it to check in the data base for the ntid
import apiClient2 from '../utils/apiClient2';

import backgroundImage from '../pages/images/SM1085970.jpg';
import Logo from '../pages/images/LIVA Logo - 3x.png';
import { cleanup } from '@testing-library/react';

function LoginPage() {
  const [ntid, setNtid] = useState('');
  const [password, setPassword] = useState('');
  const [selectedChannel, setSelectedChannel] = useState('');
  const [channelData, setChannelData] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showChannelSelection, setShowChannelSelection] = useState(false);
  const { setUserNTID, setUserChannel, userNTID } = useContext(UserContext);
  const { setUser } = useContext(AuthContext);
  let [clean_url_required, setCleanUrlRequired] = useState(false)
  const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY

  const location = useLocation()
  let navigate = useNavigate();

  

  useEffect(() => {
    const hasKey = window.location.search.includes('key=');
    if (!hasKey) {
      // No SSO key present — nothing to do here.
      // Either restore an existing session or just stay on the login page.
      if (localStorage.getItem('session_token') != null) {
        setUserNTID(localStorage.getItem('ntid'));
        setUserChannel('Agency');
        setUser({ username: localStorage.getItem('ntid'), channel: 'Agency' });
        navigate('/dashboard/customer-segmentation');
      }
      window.location.href = '/#/unauthorized';
      return; // stop here — don't fall through to the SSO flow below
    }
    const params = new URLSearchParams(location.search);
    let user_type = 'employee'
    let ssoKey = decodeURIComponent(window.location.search.split('?key=')[1]);            // already decoded by URLSearchParams
    let ntid = decodeURIComponent(window.location.search.split('?key=')[0]);     
    let encUserId = ssoKey.split('|')[0] || '';            // already decoded by URLSearchParams
       // already decoded by URLSearchParams
    if (false) {
      console.log("here")
      // window.location.href = '/#/unauthorized';
      return
    } else {
      (async () => {
        try {
          if (window.location.href.includes('key')){
            localStorage.clear()
          }
          if (localStorage.getItem('session_token') == null) {
            console.log("debugg", encUserId)
            console.log("debug2 herer", encUserId, ssoKey)
            setCleanUrlRequired(true)
            // split encUserId|encKey from the URL
            const userId = decryptAES(encUserId) || encUserId;

            try {
              user_type = ssoKey.split('|')[2]
              localStorage.setItem('ntid', userId);
              localStorage.setItem('user_ntid', userId);
            } catch(e) {
              console.log("unable to get user type")
              window.location.href = '/#/unauthorized';
              return
            }
            // call SSO-JWT with: key (combined) + agentId (plain user id)
            localStorage.setItem('originsl_ssoKey', ssoKey)
            localStorage.setItem('original_userId',userId)
            localStorage.setItem('original_user_type', user_type)

            const res = await updateUserIdSSO(ssoKey, userId, user_type);
            localStorage.setItem('session_id',Math.floor(Math.random() * 9000000000) + 1000000000)
            // store token if Apigee attached it
            if ('jwt-token' in res) {
              localStorage.setItem('session_token', res['jwt-token']);
            }
            setUserNTID(userId);
            // 2) Also store it in memory for encryption usage
            // setInMemoryNTID(ntid);  
            // Now show the channel selection UI
            try {
              // userNTID is now available from the context at the component level
              setUserChannel('Agency');
              // Set user in AuthContext to indicate we are logged in
              setUser({ username: userNTID, channel: 'Agency' });
              // Navigate to protected route
            } catch (err) {
              console.error('Error in userindatabase call:', err);
              setError('User not authorized. Please contact admin.');
            }
          
          } else {
            setUserNTID(localStorage.getItem('ntid'));
            setUserChannel('Agency');
            console.log("debug3")
            // Set user in AuthContext to indicate we are logged in
            setUser({ username: localStorage.getItem('ntid'), channel: 'Agency' });
            console.log("debug5")
            if (localStorage.getItem('location_history') == 'product_recommendation') {
              console.log("debug6")
              localStorage.setItem('location_history', 'product_recommendation_commited')
              navigate('dashboard/product-recommendation');
            } else if(localStorage.getItem('location_history') ==  'customer_segmentation') {
              localStorage.setItem('location_history', 'customer_segmentation_commited')
              navigate('/dashboard/customer-segmentation');
            }
            else{
                navigate('/dashboard/customer-segmentation');

            }
          }

        } catch (e) {
          console.error('SSO login failedeee', e);
          window.location.href = '/#/unauthorized';
        } finally {
          // clean ?key= from URL
          if (clean_url_required) {
            const cleanUrl = `${window.location.origin}${window.location.pathname}`;
            console.log("cleanurl", cleanUrl)
            window.history.replaceState({}, document.title, cleanUrl);
            navigate('/dashboard/customer-segmentation');
            setCleanUrlRequired(false)
          }
          // navigate('/dashboard/customer-segmentation');

        }

      })();
    }
  }, [clean_url_required, userNTID]);



  // Only fetch channels after the user is authenticated and showChannelSelection is true
  useEffect(() => {
    const fetchChannels = async () => {
      if (showChannelSelection) {
        try {
          // const response = await axios.get('http://localhost:8000/liva/channels', { withCredentials: true });
          const response = await apiClient.post('/channels',
            {
              ntID: userNTID
            },
            { withCredentials: true });
          setChannelData(response.data.channels);
        } catch (err) {
          console.error('Error fetching channels:', err);
          setChannelData([]);
        }
      }
    };
    fetchChannels();
  }, [showChannelSelection]);
  useEffect(() => {
    const handlePopState = () => window.history.pushState(null, "", window.location.href);
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const encryptData = (data) => {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(PUBLIC_KEY);
    return encryptor.encrypt(data);
  };
  const handleLoginSubmit = async () => {
    if (!ntid || !password) {
      setError('Please enter NTID and Password');
      return;
    }
    try {
      // setIsLoading(true);
      // const encryptedNTID = encryptData(ntid);
      // const encryptedPassword = encryptData(password);
      // const encryptedMetaData = encryptData(
      //   JSON.stringify({
      //     ntid: ntid,
      //     timestamp: Date.now(),
      //   })
      // );
      setIsLoading(true);
      const encryptedNTID = (ntid);
      const encryptedPassword = (password);
      const encryptedMetaData = (
        JSON.stringify({
          ntid: ntid,
          timestamp: Date.now(),
        })
      );
      // Call the const.jwt endpoint
      // const response = await axios.post('https://apignonprod.iciciprulife.com/v1/generate/ldap/encrypted/authentication', {
      console.log({
        ntID: encryptedNTID,
        password: encryptedPassword,
        channel: '',
        encData: encryptedMetaData,
      })
      const response = await apiClient2.post(process.env.REACT_APP_API_BASE_URLE + '/v1/generate/ldap/encrypted/liva/jwt', {
        ntID: encryptedNTID,
        password: encryptedPassword,
        channel: '',
        encData: encryptedMetaData,
      });
      console.log(response)

      // // Use mockResponse instead of actual response
      // const response = mockResponse;
      // if (response.data.Token) {
      //   toast.success("Authentication Successful!");
      //this is for apignonprod
      // if (response.data.Status=="Login Successful") {
      //this is for apidex
      if (response.data.message == "User found and token issued") {
        // Extract NTID from response.data.data if available
        let userInfo;
        if (typeof response.data.data === 'string') {
          try {
            userInfo = JSON.parse(response.data.data);
          } catch {
            userInfo = { NTID: ntid };
          }
        } else {
          userInfo = response.data.data || { NTID: ntid };
        }
        // Store NTID in userContext for frontend usage
        setUserNTID(ntid);
        // 2) Also store it in memory for encryption usage
        // setInMemoryNTID(ntid);  
        // Now show the channel selection UI
        // setShowChannelSelection(true);
        setUserChannel(selectedChannel);
        // Set user in AuthContext to indicate we are logged in
        setUser({ username: userNTID, channel: selectedChannel });
        // Navigate to protected route
        navigate('/dashboard/customer-segmentation');

      } else {
        setError("Authentication Failed!");
      }
    } catch (error) {
      console.error("Error:", error);
      setError(
        error.response?.data?.message || "Something went wrong. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };
  const handleChannelConfirm = async () => {
    if (!selectedChannel) {
      setError('Please select a channel');
      return;
    }
    try {
      // userNTID is now available from the context at the component level
      const response = await apiClient.post('/userindatabase', {
        ntid: userNTID,
        user_id: userNTID,
        channel: selectedChannel,
        ntID: userNTID
      }, { withCredentials: true });
      // If success, store channel in userContext
      setUserChannel(selectedChannel);
      // Set user in AuthContext to indicate we are logged in
      setUser({ username: userNTID, channel: selectedChannel });
      // Navigate to protected route
      navigate('/dashboard/customer-segmentation');
    } catch (err) {
      console.error('Error in userindatabase call:', err);
      setError('User not authorized. Please contact admin.');
    }
  };
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'none',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {/* Background with the left side content */}
      <Box
        sx={{
          width: '110%',
          height: '110%',
          position: 'absolute',
          top: 0,
          left: 0,
          backgroundImage: `linear-gradient(rgba(255, 239, 213, 0.7), rgba(255, 239, 213, 0.7)), url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          zIndex: 0,
        }}
      >
        {/* Text overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '12%',
            transform: 'translateY(-50%)',
            zIndex: 1,
            textAlign: 'left',
          }}
        >
          <Typography
            variant="h1"
            sx={{
              color: '#002f6c',
              fontWeight: 'bold',
              fontSize: '4.5rem',
              lineHeight: 1.2,
              fontFamily: 'Mulish-Bold, sans-serif',
            }}
          >
            Understanding needs.
          </Typography>
          <Typography
            variant="h1"
            sx={{
              color: '#002f6c',
              fontWeight: 'bold',
              fontSize: '3.5rem',
              lineHeight: 1.2,
              fontFamily: 'Mulish-Bold, sans-serif',
            }}
          >
            Delivering value.
          </Typography>
        </Box>
      </Box>
      {/* Login Box */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          right: '15%',
          transform: 'translateY(-50%)',
          width: '380px',
          zIndex: 2,
        }}
      >
        {/* Login Card */}
        <Card
          sx={{
            borderRadius: '15px',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
            backgroundColor: 'white',
            padding: '24px 20px',
            width: '100%',
          }}
        >
          <CardContent
            sx={{
              padding: '8px 10px',
              '&:last-child': { paddingBottom: '20px' },
            }}
          >
            {/* Logo */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '20px',
              }}
            >
              <img
                // src="/logo_liv.JPG" // Adjust path as needed
                src={Logo}
                alt="LIVA Logo"
                style={{
                  height: '96px',
                  marginRight: '0px',
                }}
              />
              {/* <Typography
              sx={{
                color: '#C00026',
                fontSize: '22px',
                fontWeight: 'bold',
                fontFamily: 'Mulish-Bold, sans-serif',
              }}
            >
              LIVA
            </Typography> */}
            </Box>
            {!showChannelSelection ? (
              <>
                {/* Login Form */}
                {/* <Typography
                sx={{
                  color: '#333',
                  fontSize: '16px',
                  marginBottom: '24px',
                  fontFamily: 'Mulish-Regular, sans-serif',
                }}
              >
                {error ? (
                  <span style={{ color: 'red' }}>{error}</span>
                ) : (
                  "Sign in to continue"
                )}
              </Typography> */}

                Version 1.6
                <TextField
                  placeholder="NTID"
                  fullWidth
                  value={ntid}
                  onChange={(e) => setNtid(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircleIcon sx={{ color: '#757575' }} />
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  size="small"
                  sx={{
                    mb: 2,
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '30px',
                      backgroundColor: '#f5f5f5',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                  }}
                />
                <TextField
                  placeholder="Password"
                  type="password"
                  fullWidth
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon sx={{ color: '#757575' }} />
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  size="small"
                  sx={{
                    mb: 1,
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '30px',
                      backgroundColor: '#f5f5f5',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                  }}
                />
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    mb: 2,
                  }}
                >
                  {/* <Link
                  component="button"
                  variant="body2"
                  underline="hover"
                  onClick={() => {
                    // Forgot password handler
                    console.log('Forgot password clicked');
                  }}
                  sx={{
                    color: '#757575',
                    fontSize: '12px',
                    fontFamily: 'Mulish-Regular, sans-serif',
                  }}
                >
                  Forgot password?
                </Link> */}
                </Box>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleLoginSubmit}
                  disabled={isLoading}
                  sx={{
                    padding: '10px',
                    borderRadius: '30px',
                    backgroundColor: '#FF9800',
                    color: 'white',
                    textTransform: 'none',
                    fontFamily: 'Mulish-Bold, sans-serif',
                    fontSize: '18px',
                    boxShadow: 'none',
                    '&:hover': {
                      backgroundColor: '#F57C00',
                      boxShadow: 'none',
                    },
                  }}
                >
                  {isLoading ? 'Please wait...' : 'Get Started'}
                </Button>
              </>
            ) : (
              <>
                {/* Channel Selection */}
                <Typography
                  // sx={{
                  //   color: '#333',
                  //   fontSize: '32px',
                  //   marginBottom: '24px',
                  //   fontFamily: 'Mulish-Bold, sans-serif',
                  // }}
                  variant="h1"
                  sx={{
                    display: 'flex',
                    color: '#002f6c',
                    fontWeight: 'bold',
                    fontSize: '1.5rem',
                    lineHeight: 1.2,
                    fontFamily: 'Mulish-Bold, sans-serif',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    marginBottom: '24px',

                  }}
                >
                  {error ? (
                    <span style={{ color: 'red' }}>{error}</span>
                  ) : (
                    "Select Channel"
                  )}
                </Typography>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <Select
                    value={selectedChannel}
                    displayEmpty
                    onChange={(e) => setSelectedChannel(e.target.value)}
                    renderValue={(selected) => {
                      if (!selected) {
                        return <Typography sx={{ color: '#757575' }}>Channel</Typography>;
                      }
                      return selected;
                    }}
                    sx={{
                      borderRadius: '30px',
                      backgroundColor: '#f5f5f5',
                      '.MuiOutlinedInput-notchedOutline': { border: 'none' },
                      height: '40px',
                    }}
                  >
                    {channelData.map((channel, index) => (
                      <MenuItem key={index} value={channel}>
                        {channel}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleChannelConfirm}
                  sx={{
                    padding: '10px',
                    borderRadius: '30px',
                    backgroundColor: '#FF9800',
                    color: 'white',
                    textTransform: 'uppercase',
                    fontFamily: 'Mulish-Bold, sans-serif',
                    boxShadow: 'none',
                    '&:hover': {
                      backgroundColor: '#F57C00',
                      boxShadow: 'none',
                    },
                  }}
                >
                  CONFIRM CHANNEL
                </Button>
              </>
            )}
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
export default LoginPage;